<div
  class="avatar"
  [pTooltip]="name || 'N/A'"
  tooltipPosition="top"
  [style]="{
    'background-color': color,
    'color': !!color ? '#fff' : '#333',
    'border-color': !!color ? 'transparent' : '#ccc',
  }"
>
  {{ text }}
</div>
